import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const MarketingSettingsComponent = ({ selectMarketingSettings, handleInnerFormChange }: any) => {

    return (
        <>
        <AccordionContainer
            child={
            <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                <InputContainer
                    label="Allowed SMS Count"
                    name="AllowedSMSCount"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event.target.value,
                        'SMSCampaignSettings.AllowedSMSCount',
                        selectMarketingSettings?.SMSCampaignSettings
                    )
                    }}
                    type="text"
                    value={selectMarketingSettings?.SMSCampaignSettings?.AllowedSMSCount}
                />
                <InputContainer
                    label="Allowed Email Count"
                    name="AllowedEmailCount"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event.target.value,
                        'EmailCampaignSettings.AllowedEmailCount',
                        selectMarketingSettings?.EmailCampaignSettings
                    )
                    }}
                    type="text"
                    value={selectMarketingSettings?.EmailCampaignSettings?.AllowedEmailCount}
                />
            </div>
            }
        expandedPanel="Marketing Settings"
        headerTitle="Marketing Settings"
        />
        </>
  )
}
export default MarketingSettingsComponent;
